/** Altura da barra fixa de salvar/cancelar que chega na lateral direita. */
export function alturaRodapeAcao(raiz: ParentNode = document): number {
  const alturaJanela = window.innerHeight;
  const larguraJanela = window.innerWidth;
  let altura = 0;
  for (const el of raiz.querySelectorAll('footer')) {
    const estilo = window.getComputedStyle(el);
    if (estilo.position !== 'fixed' || estilo.display === 'none' || estilo.visibility === 'hidden') {
      continue;
    }
    const rect = el.getBoundingClientRect();
    if (rect.height < 8 || rect.width < 80) continue;
    if (rect.bottom < alturaJanela - 4) continue;
    if (rect.right < larguraJanela - 48) continue;
    const ocupa = Math.max(0, alturaJanela - rect.top);
    if (ocupa > altura) altura = ocupa;
  }
  return Math.round(altura);
}
